import axios from 'axios';
import { hashHistory } from 'react-router';

import url from '../../components/common/BaseURL';

const baseURL = url.baseURL;

export const onEmailChange = (text) => {
    return {
        type: 'EMAIL_CHANGE_LOGIN',
        payload: text
    };
};

//Stores the password typed in login screen
export const onPasswordChange = (text) => {
    return {
        type: 'PASSWORD_CHANGE_LOGIN',
        payload: text
    };
};

//Login AJAX call
export const login = ({ emailLogin, passwordLogin }) => {
    return (dispatch) => {
        dispatch({ type: 'LOGIN' });
        const auth = btoa(`${emailLogin}:${passwordLogin}`);
        axios.post(baseURL + 'users', {}, {
            headers: {
                Authorization: `Basic ${auth}`,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        }).then(response => {
            localStorage.setItem('data', JSON.stringify(response.data.data));
            dispatch({ type: 'LOGIN_SUCCESS', payload: response.data.data });
            hashHistory.push('/Dashboard');
        }).catch(err => {
            dispatch({ type: 'LOGIN_FAIL' });
            
            console.log(err, err.response);
        });
    };
};



// WEBPACK FOOTER //
// ./src/actions/Auth/AuthActions.js